var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-content",style:(_vm.style)},[_c('img',{attrs:{"src":require("../images/no_data.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }